module.exports = __webpack_public_path__ + "img/Alchimeia_round.9895f3ec.png";